import { useEffect, useMemo } from 'react';

const createLions = () => [
  { id: 'lion-1', delay: '0ms', lane: '22vh', duration: '1800ms', size: '18px' },
  { id: 'lion-2', delay: '220ms', lane: '34vh', duration: '2050ms', size: '16px' },
  { id: 'lion-3', delay: '410ms', lane: '46vh', duration: '1920ms', size: '17px' },
  { id: 'lion-4', delay: '620ms', lane: '58vh', duration: '2140ms', size: '15px' },
];

export const AquaLionRun = ({ onComplete }) => {
  const lions = useMemo(() => createLions(), []);

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      onComplete?.();
    }, 2600);

    return () => window.clearTimeout(timeoutId);
  }, [onComplete]);

  return (
    <div className="aqua-lion-run" aria-hidden="true">
      {lions.map((lion) => (
        <span
          key={lion.id}
          className="aqua-lion-run-item"
          style={{
            '--lion-delay': lion.delay,
            '--lion-lane': lion.lane,
            '--lion-duration': lion.duration,
            '--lion-size': lion.size,
          }}
        >
          🦁
        </span>
      ))}
    </div>
  );
};
